import type { ProductSecuredLoanConfig } from '../../@types/context/product-secured-loan-config.types';

export const securedLoanNoConfig: Omit<ProductSecuredLoanConfig, 'case'> = {
  config: {
    amount: {
      min: 100_000,
      max: 10_000_000,
      default: 2_000_000,
      step: 50_000,
    },
    duration: {
      min: 1,
      max: 30,
      default: 20,
      step: 1,
    },
  },
};
